import { formatInTimeZone } from "date-fns-tz";
import { DEFAULT_TIME_ZONE } from "../utils/Constants";
import { getSelectedHospitalValue } from "../modules/hospitalModule/hooks/useSelectedHospitalValue";
import { DATE_TYPE } from "../utils/Types";

export default function formatDateTime(
  date?: DATE_TYPE | null,
  isTimeZoneEnable: boolean = true,
  formatStr: string = "dd/MM/yyyy hh:mm:ss a"
) {
  try {
    if (!date) {
      return "";
    }
    if (isTimeZoneEnable) {
      const { timeZone } = getSelectedHospitalValue();

      return formatInTimeZone(date, timeZone ?? DEFAULT_TIME_ZONE, formatStr);
    }
    return formatInTimeZone(date, "UTC", formatStr);
  } catch (error) {
    console.log(error);
  }

  return "";
}

export function formatTimeString(
  timeStr: string | null | undefined,
  formatStr: string = "hh:mm aaa"
): string {
  if (!timeStr) return "--";
  try {
    // Parse "hh:mm:ss AM/PM" — JS Date constructor does not reliably handle 12-hour AM/PM format
    const match = /^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i.exec(
      timeStr.trim()
    );
    if (!match) return timeStr;

    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const seconds = match[3] ? parseInt(match[3], 10) : 0;
    const period = match[4].toUpperCase();

    if (period === "AM" && hours === 12) hours = 0;
    if (period === "PM" && hours !== 12) hours += 12;

    // Date is irrelevant — use a fixed reference date, only the time portion matters
    const utcDate = new Date(Date.UTC(2000, 0, 1, hours, minutes, seconds));

    return formatDateTime(utcDate, true, formatStr);
  } catch {
    return timeStr;
  }
}